var map = {
	"./companies.js": 14691,
	"./contract.js": 96711,
	"./distributions.js": 55945,
	"./documentation.js": 36457,
	"./extension.js": 19419,
	"./feedback.js": 97287,
	"./filter-data.js": 67774,
	"./groups.js": 93001,
	"./heatmap.js": 67175,
	"./kpis.js": 53595,
	"./lexicons.js": 55614,
	"./locale.js": 6941,
	"./report-templates.js": 79954,
	"./survey.js": 12820,
	"./surveys.js": 47531,
	"./topics.js": 95008,
	"./trends.js": 22570,
	"./user.js": 28230,
	"./users.js": 27610
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52115;